import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'side-search',
  templateUrl: 'side-search.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideSearchComponent {
  @Input() fuzzyResults: any;
  @Output() goToCompany: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  trackByFn(index, item) {
    return item._id;
  }
  goCompany($event, item) {
    this.goToCompany.emit(item.ticker);
  }

}



// WEBPACK FOOTER //
// ./src/components/side-search/side-search.ts